export interface ValidationOptions {
    formatCurrency: (value: number) => string;
}

export const validationEnabledFn = (id: string, enabled: boolean) => !!(id || enabled);
